import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";

import logger from "../../../../logger";

export const recsKeys = {
  all: ["recs"],
  lists: () => [...recsKeys.all, "list"],
  list: (filters) => [...recsKeys.lists(), { filters }],
  items: () => [...recsKeys.all, "item"],
  item: (args) => [...recsKeys.items(), args],
};

// Queries
export function useRecording(func, args, queryOptions = {}) {
  return useQuery({
    queryKey: recsKeys.item(args.mediaPipelineId),
    queryFn: () => func(args.mediaPipelineId),
    ...queryOptions,
  });
}

export function useRecordings(func, args, queryOptions = {}) {
  return useQuery({
    queryKey: recsKeys.list(args),
    queryFn: () => func(args),
    ...queryOptions,
  });
}

export function useSubmissions(func, args, queryOptions = {}) {
  return useQuery({
    queryKey: recsKeys.item(args),
    queryFn: () => func(args),
    ...queryOptions,
  });
}

export function useRecEvents(func, args, queryOptions = {}) {
  return useQuery({
    queryKey: recsKeys.item(args),
    queryFn: () => func(args),
    ...queryOptions,
    staleTime: 0,
  });
}

export function useMeetingRecs(func, args, queryOptions = {}) {
  return useQuery({
    queryKey: recsKeys.list(args),
    queryFn: () => func(args),
    ...queryOptions,
  });
}

// Mutations
export function useCreateRec(func) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (variables) => func(variables),
    onError: (error) => {
      // An error happened!
      logger.error(error);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: recsKeys.lists() });
    },
  });
}

export function useSaveRec(func) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (variables) => func(variables),
    onError: (error) => {
      // An error happened!
      logger.error(error);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: recsKeys.lists() });
    },
  });
}

export function useDeletePipeline(func) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (variables) => func(variables),
    onError: (error) => {
      // An error happened!
      logger.error(error);
    },
    onSuccess: (variables) => {
      queryClient.invalidateQueries({ queryKey: recsKeys.lists() });
      queryClient.invalidateQueries({
        queryKey: recsKeys.item(variables.mediaPipelineId),
      });
    },
  });
}

export function useUpdateRec(func) {
  return useMutation({
    mutationFn: (variables) => func(variables),
    onError: (error) => {
      // An error happened!
      logger.error(error);
    },
    onSuccess: () => {},
  });
}
